import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=320be68c&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=ts"
export * from "./ProductsList.vue?vue&type=script&lang=ts"
import style0 from "./ProductsList.vue?vue&type=style&index=0&id=320be68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320be68c",
  null
  
)

export default component.exports